import { getAll as getAllProduitReseauNumerique } from '@/api/produit/produitReseauNumerique';
import genererCritereRechercheProduitReseau from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitReseauNumerique';
import transform from '@/services/catalogue/filters/produitReseauNumeriqueServerTableDataTransformer';
import * as allTypes from '../mutation-type';
import * as types from './produitReseauNumerique-mutation-type';

export function initialState() {
  return {
    produits: [],
    totalProduits: 0,
    typeProduit: null,
    criteresRecherche: genererCritereRechercheProduitReseau(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PRODUITS](state, produits) {
    state.produits = produits;
  },
  [types.SET_TOTAL_PRODUITS](state, totalProduits) {
    state.totalProduits = totalProduits;
  },
  [types.SET_CRITERES_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadProduitsReseauNumerique({ commit }, data) {
    const response = await getAllProduitReseauNumerique(data);
    response.data.result.items.forEach(el => {
      el.selected = false;
    });
    commit(types.SET_LAST_PAYLOAD, transform(data));
    commit(types.SET_PRODUITS, response.data.result.items);
    commit(types.SET_TOTAL_PRODUITS, response.data.result.totalCount);
    return {};
  },
};

const getters = {
  produits: state => {
    return state.produits;
  },
  totalProduits: state => {
    return state.totalProduits;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
